import { StaggerTransitionRoot, Transition } from "@components/motion/Transition"
import { SidebarLayout } from "@components/page/SidebarLayout"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { AnimatePresence } from "framer-motion"

export default defineView("page", (props) => {
  return (
    <SidebarLayout nav={props.page?.sectionNav!}>
      <AnimatePresence mode="wait">
        <StaggerTransitionRoot key={props.page?.id}>
          <ContentBlocks
            blocks={props.page?.contentBlocks}
            wrapBlock={(child, ctx) => {
              if (ctx.current.flags?.selfAnimates) {
                return child
              } else {
                return <div data-transition="fade">{child}</div>
              }
            }}
          />
        </StaggerTransitionRoot>
      </AnimatePresence>
    </SidebarLayout>
  )
})
